import React from 'react';

function UploadBlack({ fill = '#1D1C1D', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5835 16.6666C4.25016 16.6666 3.9585 16.5416 3.7085 16.2916C3.4585 16.0416 3.3335 15.75 3.3335 15.4166V12.4375H4.5835V15.4166H15.4168V12.4375H16.6668V15.4166C16.6668 15.75 16.5418 16.0416 16.2918 16.2916C16.0418 16.5416 15.7502 16.6666 15.4168 16.6666H4.5835ZM9.37516 13.4791V5.74998L6.87516 8.24998L5.97933 7.35415L10.0002 3.33331L14.021 7.35415L13.1252 8.24998L10.6252 5.74998V13.4791H9.37516Z" fill={fill} />
    </svg>

  );
}

export default UploadBlack;
